/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import store from '@/app/store/store';
import { camelize } from '@/app/utils/helpers';
import SidebarPopUp from '../../components/popup';
// import CheckBoxControl from "../../controlsv2/checkbox";
import CheckBoxesControl from '../../controlsv2/checkboxes';
import DropdownControl from '../../controlsv2/dropdown';
import DropdownGroupControl from '../../controlsv2/dropdown-group';
import RangePickerControl from '../../controlsv2/range-picker';
import animationStyle from '../../interactions/configs/animation-style';
import { getActionDataEditorDefault } from '../actions.actions';
import { animations } from '../actions.animations.config';
import { allAtomsIntegration } from '../actions.config';
import { actionHtml, actionSettingsHtml } from '../actions.html';
import type { ActionDataEditor, ActionData, AtomConfig } from '../type';

/**
 * ActionItem
 */
export default class ActionItem implements ActionDataEditor {
  name: string;
  description: string;
  settings?: any;
  atomKey?: string | undefined;
  key: string;
  type: number;
  data?: any;
  lg?: any;
  md?: any;
  sm?: any;
  xs?: any;
  support = true;
  currentScreen = '';

  $actionSettings: JQuery;
  $html: JQuery;
  $targetActions: JQuery | undefined;
  $after: JQuery | undefined;

  $gfResTool: JQuery;

  flagRemoved = false;
  flagDeviceSettings = false;
  dropdownMoreSettings: DropdownGroupControl;

  parentCallback: any;

  listSettings = {};
  readonly PREFIX = 'gf__';

  /**
   * constructor
   * @param $targetActions ..
   * @param actionDataEditor ..
   * @param $after ..
   */
  constructor($targetActions: JQuery, actionDataEditor: ActionDataEditor, $after?: JQuery) {
    this.setUpData(actionDataEditor);

    this.$targetActions = $targetActions;
    this.$after = $after;
    this.$gfResTool = jQuery('#gfResTool');

    this.$html = jQuery(
      actionHtml({
        key: this.key,
        name: this.getName(),
        type: this.type,
        description: this.description,
        settings: this.settings,
        support: this.support,
        data: this.data,
        lg: this.lg,
        md: this.md,
        sm: this.sm,
        xs: this.xs,
      }),
    );

    if (this.$after) {
      this.$after.after(this.$html);
    } else {
      this.$targetActions.append(this.$html);
    }
    this.$actionSettings = this.$html.find('.action-settings');

    this.initSettings();
    this.applyEvents();
  }

  /**
   * setUpData
   * @param actionDataEditor .
   * @param fillDataFromSettings boolean
   */
  setUpData(actionDataEditor: ActionDataEditor, fillDataFromSettings = 'fill'): void {
    this.key = actionDataEditor.key;
    this.name = actionDataEditor.name;
    this.type = actionDataEditor.type;
    this.description = actionDataEditor.description;
    this.settings = actionDataEditor.settings || [];
    this.support = actionDataEditor.support != undefined ? actionDataEditor.support : true;
    this.data = actionDataEditor.data || {};
    this.lg = actionDataEditor.lg || {};
    this.md = actionDataEditor.md || {};
    this.sm = actionDataEditor.sm || {};
    this.xs = actionDataEditor.xs || {};

    //add animation select to first setting
    if (this.type == 1) {
      if (this.settings[0]) {
        if (this.settings[0].key != 'animation') {
          const animationOptions = animations.map((animation) => {
            return {
              value: animation.key,
              text: animation.name,
            };
          });
          const animationSetting = {
            key: 'animation',
            name: 'Animation',
            type: 'select',
            value: this.key,
            options: animationOptions,
          };
          this.settings.unshift(animationSetting);
        } else {
          this.settings[0].value = this.key;
        }
      }

      //add preview animation to last setting
      if (
        this.settings[this.settings.length - 1] &&
        this.settings[this.settings.length - 1].key != 'preview-animation'
      ) {
        const animationSetting = {
          key: 'preview-animation',
          name: 'View Animation',
          type: 'button',
          icon: 'play',
        };
        this.settings.push(animationSetting);
      }
    }

    //fill data from settings
    if (fillDataFromSettings == 'fill') {
      for (let i = 0; i < this.settings.length; i++) {
        const key = this.settings[i].key;

        //ignore animation & preview-animation
        if (key == 'animation' || key == 'preview-animation') {
          continue;
        }

        if (typeof this.data[key] == 'undefined') {
          this.data[key] = this.settings[i].value;
        }
      }
    }

    //replace data from settings
    if (fillDataFromSettings == 'replace') {
      for (let i = 0; i < this.settings.length; i++) {
        const key = this.settings[i].key;
        //ignore animation & preview-animation
        if (key == 'animation' || key == 'preview-animation') {
          continue;
        }

        this.data[key] = this.settings[i].value;
      }
    }
  }

  /**
   * applyEvents
   */
  applyEvents(): void {
    const _this = this;
    //more settings event
    const $moreSettings = this.$html.find('.expand-list ul');
    const opts = {
      type: 'simple',
      animationSpeed: 100,
      /**
       * onChange
       * @param data .
       */
      onChange: (data: any) => {
        if (data.value == 'duplicate') {
          _this.duplicate();
          return;
        }
        if (data.value == 'device-settings') {
          //
          _this.toggleDeviceSettings();
          return;
        }
        if (data.value == 'move-up') {
          //
          _this.moveUp();
          return;
        }
        if (data.value == 'move-down') {
          //
          _this.moveDown();
          return;
        }
        if (data.value == 'delete') {
          new SidebarPopUp({
            title: 'Deleting This Action?',
            description: `${this.getName()} will be removed from your actions list.`,
            primaryButton: {
              text: 'Delete',
              class: 'gf_btn-danger', // check or add class in style.scss on component
            },
            secondaryButton: {
              text: 'Cancel',
            },
            /**
             * On click delete
             */
            onClickedPrimary() {
              _this.remove();
            },
          });
          return;
        }
      },
    };

    //add event
    $moreSettings.each(function () {
      _this.dropdownMoreSettings = new DropdownGroupControl(jQuery(this), opts);
    });

    this.$html
      .find('.expand')
      .off('click.expand-action')
      .on('click.expand-action', function () {
        _this.dropdownMoreSettings.toggle();
      });

    //collapse
    this.$html
      .find('.action-head')
      .off('click')
      .on('click', function (event) {
        //ignore if click expand
        if (
          jQuery(event.target).closest('.expand').length ||
          jQuery(event.target).closest('.expand-list').length ||
          $(event.target).is('.expand')
        ) {
          return;
        }

        const $actionItem = _this.$targetActions?.find('.target-action');
        const $currentTargetAction = jQuery(this).closest('.target-action');

        if ($actionItem) {
          $actionItem.each(function () {
            if (jQuery(this).is($currentTargetAction)) {
              if (jQuery(this).hasClass('active')) {
                jQuery(this).removeClass('active').find('.action-settings').stop(true, false).slideUp();
              } else {
                jQuery(this).addClass('active').find('.action-settings').stop(true, false).slideDown();
              }
            } else {
              jQuery(this).removeClass('active').find('.action-settings').stop(true, false).slideUp();
            }
          });
        }
      });
  }

  /**
   * getName
   * @returns string
   */
  getName(): string {
    if (this.type == 1) {
      return 'Animation - ' + this.name;
    }
    return this.name;
  }

  /**
   * refreshName
   */
  refreshName(): void {
    this.$html.find('.action-name').attr('data-key', this.key).text(this.getName());
  }

  /**
   * Open Settings
   */
  initSettings(): void {
    const _this = this;

    const settingsHtml = actionSettingsHtml({
      key: this.key,
      name: this.name,
      type: this.type,
      description: this.description,
      settings: this.settings,
      support: this.support,
      data: this.data,
      lg: this.lg,
      md: this.md,
      sm: this.sm,
      xs: this.xs,
    });

    // this.$actionSettings.children().remove();
    this.$actionSettings.html(settingsHtml);

    for (let i = 0; i < _this.settings.length; i++) {
      //
      const name = _this.settings[i].key;
      const type = _this.settings[i].type;

      switch (type) {
        case 'select':
          this.$actionSettings.find('[name="' + name + '"]').each(function () {
            // Listen onChange
            const opts = {
              /**
               * onChange
               * @param data .
               */
              onChange: (data: any) => {
                if (data.name == 'animation') {
                  if (data.value == _this.key) {
                    //ignore
                    return;
                  }
                  //reset data
                  const defaultData = getActionDataEditorDefault(data.value);
                  _this.setUpData(defaultData, 'replace');

                  _this.refreshName();
                  _this.initSettings();
                  store.setValue('update-action', 1);
                } else {
                  _this.updateData(data.name, data.value);
                }
              },
            };

            Object(_this.listSettings)[name] = new DropdownControl(jQuery(this), opts);
          });
          break;
        case 'range':
          this.$actionSettings.find('[name="' + name + '"]').each(function () {
            // Listen onChange
            const opts = {
              /**
               * onChange
               * @param data .
               */
              onChange: (data: any) => {
                _this.updateData(data.name, data.value);
              },
            };
            Object(_this.listSettings)[name] = new RangePickerControl(jQuery(this), opts);
          });
          break;
        case 'checkbox':
          {
            // Listen onChange
            const $checkboxes = this.$actionSettings.find('[name="' + name + '"]');
            const opts = {
              /**
               * onChange
               * @param data .
               */
              onChange: (data: any) => {
                const name = data.name;
                const value = data.value;
                //value of checkbox is array
                _this.updateData(name, value);
              },
            };
            Object(_this.listSettings)[name] = new CheckBoxesControl($checkboxes, opts);
          }
          break;
        case 'button':
          {
            if (name == 'preview-animation') {
              // console.log(name);
              // Listen onChange
              const $button = this.$actionSettings.find('[name="' + name + '"]');
              let timeOut: any;
              $button.off('click.click-btn').on('click.click-btn', function () {
                //console.log();
                //get duration
                const currentScreen = _this.getCurrentScreen();
                const dataScreen = _this.getDataActionByScreen(currentScreen);
                const delay = dataScreen.delay || 0;
                const duration = dataScreen.duration || 500;
                _this.runAnimate(dataScreen);
                jQuery(this).addClass('playing');

                if (timeOut) {
                  clearTimeout(timeOut);
                }

                timeOut = setTimeout(() => {
                  jQuery(this).removeClass('playing');
                }, duration + delay);
              });
            }
          }
          break;
        default:
          break;
      }
    }

    if (this.flagDeviceSettings) {
      this.enableDeviceSettings();
    }
  }

  /**
   * convertAnimationData
   * @param key .
   * @param data .
   * @returns .
   */
  convertAnimationData(key: string, data: any): any {
    const screens = {};
    if (data.screens) {
      for (let i = 0; i < data.screens.length; i++) {
        Object(screens)[data.screens[i]] = true;
      }
    }

    let name = key;
    if (data.direction) {
      name = name + '_' + data.direction;
    }

    // {"animation":{"screens":{"lg":true,"md":true,"sm":true,"xs":true},"name":"back_in-left","delay":0,"duration":500},"interaction":{"key":"mouse-hover","type":"level2"}}
    return {
      animation: {
        screens: screens,
        name: name,
        delay: data.delay,
        duration: data.duration || 500,
        'iteration-count': data.loop || 1,
      },
      interaction: {
        key: key,
      },
    };
  }

  /**
   * FindAtomSetting
   * @param label ..
   * @returns AtomConfig | undefined
   */
  findAtomSetting(label: string): AtomConfig | undefined {
    return allAtomsIntegration.get(label);
  }

  /**
   * runAnimate
   * copy and custom from interaction/animations
   * @param data .
   * @returns .
   */
  runAnimate(data: any): Promise<string> {
    //get Animation Data
    let haveDirection = false;
    for (let i = 0; i < this.settings.length; i++) {
      if (this.settings[i].key == 'direction' && data.direction) {
        haveDirection = true;
      }
    }

    const animData = {
      animation: {
        delay: data.delay || 0,
        duration: data.duration || 500,
        name: haveDirection ? this.key + '_' + data.direction : this.key,
        screens: { lg: true, md: true, sm: true, xs: true },
      },
    };

    let animation = camelize(animData.animation.name?.replace('_', '-') || '');

    // Fix trường hợp 1 số animation tên trùng nhau như: (E) Bounce và (S) Bounce
    // Khi đó key 2 cái sẽ là bounce và bounce_
    // Dòng trên chuyển về camel case và replace _ thành - nên chỉ cần trim đi là được
    if (animation.includes('-')) {
      animation = animation.replace('-', '');
    }

    const $targetAtom = this.parentCallback('get-atom');
    const atomLabel = $targetAtom.attr('data-label') || '';
    // Target Atom Animated
    const atomSetting = this.findAtomSetting(atomLabel);

    let $target = $targetAtom.children();
    if (atomSetting) {
      if (atomSetting.target) {
        $target = $targetAtom.find(atomSetting.target).first();
      } else {
        $target = $targetAtom;
      }
    }

    // Clear all gf__animated and gf__animateName
    const gfAnimateClasses = $target.attr('class');
    const matches = gfAnimateClasses?.match(/gf__[a-zA-Z-_]*/g);
    if (matches && matches.length) {
      $target.removeClass(matches.join(' '));
    }

    // We create a Promise and return it
    return new Promise<string>((resolve, _reject) => {
      const animationName = `${this.PREFIX}${animation}`;
      const addedClass = [`${this.PREFIX}animated`];
      $target.addClass(addedClass.join(' '));

      const animStyles = (animationStyle as any)[animationName];
      if (!animStyles) {
        return;
      }

      if (animData.animation.delay != undefined) {
        const delay = animData.animation.delay;
        animStyles['animation-delay'] = `${+delay / 1000}s`;
        animStyles['-webkit-animation-delay;'] = `${+delay / 1000}s`;
      }

      if (animData.animation.duration != undefined) {
        let duration = animData.animation.duration;
        switch (animationName) {
          case 'gf__heartbeat':
            duration = +duration * 1.3;
            break;
          case 'gf__bounceIn':
          case 'gf__bounceOut':
          case 'gf__flipOutX':
          case 'gf__flipOutY':
            duration = +duration * 0.75;
            break;
        }
        animStyles['animation-duration'] = `${+duration / 1000}s`;
        animStyles['-webkit-animation-duration'] = `${+duration / 1000}s`;
      }
      for (const key of Object.keys(animStyles)) {
        $target.css(key, animStyles[key]);
      }

      /**
       * When the animation ends, we clean the classes and resolve the Promise
       */
      function handleAnimationEnd() {
        $target.removeClass(addedClass.join(' '));

        for (const key of Object.keys(animStyles)) {
          $target.css(key, '');
        }

        $target.off('animationend', handleAnimationEnd);

        resolve('Animation ended');
      }

      // Check screens then run animate
      $target.on('animationend', handleAnimationEnd);
    });
  }

  /**
   * close Settings
   */
  closeSettings(): void {
    this.$actionSettings.hide();
  }

  /**
   * enableDeviceSettings
   */
  enableDeviceSettings(): void {
    this.flagDeviceSettings = true;
    const $screens = this.$actionSettings.find('.screens');
    const $screenItem = $screens.children();

    //reset screen to ""
    this.currentScreen = '';
    $screenItem.removeClass('active');
    const currentScreen = this.getCurrentScreen();
    $screens.children('[data-screen="' + currentScreen + '"]').addClass('active');
    $screens.addClass('active');

    const _this = this;
    //add event
    $screenItem.on('click', function () {
      const screen = jQuery(this).attr('data-screen') || '';
      _this.changeCurrentScreen(screen);
      $screenItem.removeClass('active');
      $screens.children('[data-screen="' + screen + '"]').addClass('active');
    });
  }

  /**
   * disableDeviceSettings
   */
  disableDeviceSettings(): void {
    this.flagDeviceSettings = false;
    const $screens = this.$actionSettings.find('.screens');
    const $screenItem = $screens.children();

    //reset screen to ""
    this.currentScreen = '';
    $screenItem.removeClass('active');
    $screens.removeClass('active');
    $screenItem.off('click');
    this.changeCurrentScreen(this.currentScreen);
  }

  /**
   * toggleDeviceSettings
   */
  toggleDeviceSettings(): void {
    if (this.flagDeviceSettings) {
      this.disableDeviceSettings();
    } else {
      this.enableDeviceSettings();
    }
  }

  /**
   * getCurrentScreen
   * @returns .
   */
  getCurrentScreen(): string {
    return this.currentScreen ? this.currentScreen : 'lg';
  }

  /**
   * changeCurrentScreen
   * @param screen .
   */
  changeCurrentScreen(screen: string): void {
    this.currentScreen = screen;

    //change iframe
    if (this.$gfResTool.length && this.$gfResTool.data('gfrestool')) {
      const screen = this.currentScreen ? this.currentScreen : 'lg';
      this.$gfResTool.find(`.select-screen [data-size="${screen}"]`)?.first()?.trigger('click');
    }

    //disable change animation in other screen
    if (screen == '' || screen == 'lg') {
      //
      Object(this.listSettings)['animation']?.enable();
    } else {
      Object(this.listSettings)['animation']?.disable();
    }

    //change value settings
    const data = this.getDataActionByScreen(screen);

    for (let i = 0; i < this.settings.length; i++) {
      const name = this.settings[i].key;

      //ignore animation
      if (name == 'animation') {
        continue;
      }

      if (Object(this.listSettings)[name]?.setValue) {
        Object(this.listSettings)[name].setValue(data[name]);
      }
    }
  }

  /**
   * getDataActionByScreen
   * @param screen .
   * @returns .
   */
  getDataActionByScreen(screen: string): any {
    let data;
    if (!screen || screen == 'lg') {
      return this.data;
    } else if (screen == 'md') {
      data = this.md;
    } else if (screen == 'sm') {
      data = this.sm;
    } else if (screen == 'xs') {
      data = this.xs;
    }

    return { ...this.data, ...data };
  }

  /**
   * ..
   * @param key ..
   * @param value ..
   * @param screen ..
   */
  updateData(key: string, value: any, screen?: string): void {
    const updateScreen = screen || this.currentScreen;

    if (!updateScreen || updateScreen == 'lg') {
      this.data[key] = value;
    } else if (updateScreen == 'md') {
      this.md[key] = value;
    } else if (updateScreen == 'sm') {
      this.sm[key] = value;
    } else if (updateScreen == 'xs') {
      this.xs[key] = value;
    }

    store.setValue('update-action', 1);
  }

  /**
   * setSupport
   * @param support .
   */
  setSupport(support: boolean): void {
    if (this.support == support) {
      return;
    }

    this.support = support;
    if (this.support) {
      this.$html.removeClass('no-support');
    } else {
      this.$html.addClass('no-support');
    }
  }

  /**
   * setDuplicateCallback
   * @param callback .
   * @returns ..
   */
  setCallback(callback: any): void {
    this.parentCallback = callback;
  }

  /**
   * duplicate: Gọi lên callback rồi để FlowActionItem duplicate
   * @returns ..
   */
  duplicate(): void {
    this.parentCallback('duplicate');
  }

  /**
   * moveUp: Gọi lên callback
   * @returns ..
   */
  moveUp(): void {
    this.parentCallback('move-up');
  }
  /**
   * moveUp: Gọi lên callback
   * @returns ..
   */
  moveDown(): void {
    this.parentCallback('move-down');
  }

  /**
   * remove
   */
  remove(): void {
    this.$html.remove();
    this.flagRemoved = true;
    store.setValue('update-action', 1);
  }

  /**
   * ..
   * @returns ..
   */
  export(): ActionData | undefined {
    if (this.flagRemoved) {
      return undefined;
    }
    const action: ActionData = {
      key: this.key,
      type: this.type,
      data: this.data,
    };
    if (Object.keys(this.lg).length) {
      action.lg = this.lg;
    }
    if (Object.keys(this.md).length) {
      action.md = this.md;
    }
    if (Object.keys(this.sm).length) {
      action.sm = this.sm;
    }
    if (Object.keys(this.xs).length) {
      action.xs = this.xs;
    }
    return action;
  }
}
